<template>
  <BusinessesHeader>
    <TableScopeNotice v-if="tab?.notice">{{ tab.notice }}</TableScopeNotice>
    <DepositTable v-if="tab?.table === 'deposits'" :key="$route.fullPath"/>
    <CreditNoteTable v-else-if="tab?.table === 'creditNotes'" :key="$route.fullPath"/>
    <BusinessTable v-else :key="$route.fullPath" :defaultFilters="tab?.filters" :subFilters="tab?.subFilters" :openedDocument="tab?.document"/>
  </BusinessesHeader>
</template>

<script>
import BusinessTable from "@/components/tables/BusinessTable.vue";
import DepositTable from "@/components/tables/DepositTable.vue";
import CreditNoteTable from "@/components/tables/CreditNoteTable.vue";
import BusinessesHeader from "@/components/BusinessesHeader.vue";
import TableScopeNotice from "@/components/TableScopeNotice.vue";
import {BUSINESS_TABS} from "@/components/businessTabs";

export default {
  name: 'BusinessListView',
  computed: {
    tab() {
      return BUSINESS_TABS.find(tab => tab.key === this.$route.params.tab);
    }
  },
  components: {
    BusinessesHeader,
    TableScopeNotice,
    BusinessTable,
    DepositTable,
    CreditNoteTable
  }
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';
h1
  color: THEME_COLOR_PRIMARY
  span
    color: THEME_COLOR_PRIMARY_FADDED
</style>

<style lang="stylus">
main
  align-content start
</style>